'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

GroupTreeDirective=class GroupTreeDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['groupTree','selectedGroup'];
}

get templateUrl(){
return'/templates/directives/groupTreeDirective/groupTreeTemplate';
}

get controller(){
return GroupTreeDirectiveController;
}};let


GroupTreeDirectiveController=class GroupTreeDirectiveController{
static get $inject(){
return['groupTreeService','$scope'];
}

constructor(groupTreeService,$scope){
this._groupTreeService=groupTreeService;
this._$scope=$scope;
}

expandAll(){
this._$scope.$evalAsync(()=>{
this._groupTreeService.expandAllGroups();
});
}

collapseAll(){
this._$scope.$evalAsync(()=>{
this._groupTreeService.collapseAllGroups();
});
}

get groupTree(){
return this._groupTreeService.groupTree;
}

set groupTree(groupTree){

}

get selectedGroup(){
return this._groupTreeService.selectedGroup;
}

set selectedGroup(selectedGroup){
if(!_.exists(selectedGroup)){
return;
}

this._groupTreeService.selectGroupWithId(selectedGroup.id);
}

get expandedGroups(){
return this._groupTreeService.expandedGroups;
}

set expandedGroups(expandedGroups){
this._groupTreeService.expandedGroups=expandedGroups;
}};


module.exports=GroupTreeDirective;
//# sourceMappingURL=groupTreeDirective.js.map
